import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./FinanceDisabled.css";

export default function FinanceDisabled() {
  useSourceLanguage();
  const navigate = useNavigate();
  return (
    <div className="finance-disabled-page">
      <div className="finance-disabled-card">
        <div className="finance-disabled-badge"><LocalizedText source={"Pré‑lancement"} /></div>
        <h1><LocalizedText source={"Finances désactivées"} /></h1>
        <p><LocalizedText source={"Les services financiers sont désactivés tant que la licence et le dispositif KYC ne sont pas en place."} /></p>
        <div className="finance-disabled-list">
          <div><LocalizedText source={"• Pas d’achat/vente crypto contre euros"} /></div>
          <div><LocalizedText source={"• Pas de dépôts/retraits fiat"} /></div>
          <div><LocalizedText source={"• Pas de conservation de fonds clients"} /></div>
        </div>
        <div className="finance-disabled-actions">
          <button
            className="finance-btn finance-btn--primary"
            onClick={() => navigate("/")}
          ><LocalizedText source={"Retour à l’accueil"} /></button>
          <button
            className="finance-btn finance-btn--ghost"
            onClick={() => navigate("/kyc")}
          ><LocalizedText source={"Voir la page KYC (brouillon)"} /></button>
        </div>
      </div>
    </div>
  );
}
